module.exports = __webpack_public_path__ + "media/warranty-claim/photos-front-house2-57345af9.png";